/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  Violation,
  ViolationCreate,
  ViolationUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ViolationFromJSON,
    ViolationToJSON,
    ViolationCreateFromJSON,
    ViolationCreateToJSON,
    ViolationUpdateFromJSON,
    ViolationUpdateToJSON,
} from '../models/index';

export interface CreateViolationApiV1ViolationsPostRequest {
    violationCreate: ViolationCreate;
}

export interface CreateViolationApiV1ViolationsPost0Request {
    violationCreate: ViolationCreate;
}

export interface DeleteViolationApiV1ViolationsIdDeleteRequest {
    id: number;
}

export interface ReadViolationApiV1ViolationsIdGetRequest {
    id: number;
}

export interface ReadViolationsApiV1ViolationsGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadViolationsApiV1ViolationsGet0Request {
    skip?: number;
    limit?: number;
}

export interface UpdateViolationApiV1ViolationsIdPutRequest {
    id: number;
    violationUpdate: ViolationUpdate;
}

/**
 * 
 */
export class ViolationsApi extends runtime.BaseAPI {

    /**
     * Create new violation.
     * Create Violation
     */
    async createViolationApiV1ViolationsPostRaw(requestParameters: CreateViolationApiV1ViolationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Violation>> {
        if (requestParameters['violationCreate'] == null) {
            throw new runtime.RequiredError(
                'violationCreate',
                'Required parameter "violationCreate" was null or undefined when calling createViolationApiV1ViolationsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/violations/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ViolationCreateToJSON(requestParameters['violationCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViolationFromJSON(jsonValue));
    }

    /**
     * Create new violation.
     * Create Violation
     */
    async createViolationApiV1ViolationsPost(requestParameters: CreateViolationApiV1ViolationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Violation> {
        const response = await this.createViolationApiV1ViolationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new violation.
     * Create Violation
     */
    async createViolationApiV1ViolationsPost_1Raw(requestParameters: CreateViolationApiV1ViolationsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Violation>> {
        if (requestParameters['violationCreate'] == null) {
            throw new runtime.RequiredError(
                'violationCreate',
                'Required parameter "violationCreate" was null or undefined when calling createViolationApiV1ViolationsPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/violations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ViolationCreateToJSON(requestParameters['violationCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViolationFromJSON(jsonValue));
    }

    /**
     * Create new violation.
     * Create Violation
     */
    async createViolationApiV1ViolationsPost_1(requestParameters: CreateViolationApiV1ViolationsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Violation> {
        const response = await this.createViolationApiV1ViolationsPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a violation.
     * Delete Violation
     */
    async deleteViolationApiV1ViolationsIdDeleteRaw(requestParameters: DeleteViolationApiV1ViolationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Violation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteViolationApiV1ViolationsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/violations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViolationFromJSON(jsonValue));
    }

    /**
     * Delete a violation.
     * Delete Violation
     */
    async deleteViolationApiV1ViolationsIdDelete(requestParameters: DeleteViolationApiV1ViolationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Violation> {
        const response = await this.deleteViolationApiV1ViolationsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get violation by ID.
     * Read Violation
     */
    async readViolationApiV1ViolationsIdGetRaw(requestParameters: ReadViolationApiV1ViolationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Violation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readViolationApiV1ViolationsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/violations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViolationFromJSON(jsonValue));
    }

    /**
     * Get violation by ID.
     * Read Violation
     */
    async readViolationApiV1ViolationsIdGet(requestParameters: ReadViolationApiV1ViolationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Violation> {
        const response = await this.readViolationApiV1ViolationsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve violations.
     * Read Violations
     */
    async readViolationsApiV1ViolationsGetRaw(requestParameters: ReadViolationsApiV1ViolationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Violation>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/violations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViolationFromJSON));
    }

    /**
     * Retrieve violations.
     * Read Violations
     */
    async readViolationsApiV1ViolationsGet(requestParameters: ReadViolationsApiV1ViolationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Violation>> {
        const response = await this.readViolationsApiV1ViolationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve violations.
     * Read Violations
     */
    async readViolationsApiV1ViolationsGet_2Raw(requestParameters: ReadViolationsApiV1ViolationsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Violation>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/violations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViolationFromJSON));
    }

    /**
     * Retrieve violations.
     * Read Violations
     */
    async readViolationsApiV1ViolationsGet_2(requestParameters: ReadViolationsApiV1ViolationsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Violation>> {
        const response = await this.readViolationsApiV1ViolationsGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a violation.
     * Update Violation
     */
    async updateViolationApiV1ViolationsIdPutRaw(requestParameters: UpdateViolationApiV1ViolationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Violation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateViolationApiV1ViolationsIdPut().'
            );
        }

        if (requestParameters['violationUpdate'] == null) {
            throw new runtime.RequiredError(
                'violationUpdate',
                'Required parameter "violationUpdate" was null or undefined when calling updateViolationApiV1ViolationsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/violations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ViolationUpdateToJSON(requestParameters['violationUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViolationFromJSON(jsonValue));
    }

    /**
     * Update a violation.
     * Update Violation
     */
    async updateViolationApiV1ViolationsIdPut(requestParameters: UpdateViolationApiV1ViolationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Violation> {
        const response = await this.updateViolationApiV1ViolationsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
